import setItemLocalStorageUtil from 'utils/local-storage/set-item'
import getIsFreeBonusDeluxeSampleKeyCartUtil from 'modules/cart/utils/get-is-free-bonus-deluxe-sample-key'

export default function updateIsFreeBonusDeluxeSampleCartUtil (variantId) {
  logUtil('updateIsFreeBonusDeluxeSampleCartUtil').debug(`variantId=${variantId} [start]`)
  setItemLocalStorageUtil(
    getIsFreeBonusDeluxeSampleKeyCartUtil(variantId),
    true
  )
}
